var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundshade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1052,
    viewBox: "0 0 1920 1052",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_120)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M684.21 910.629L80.9898 1072.26C-83.5846 1116.36 -181.25 1285.52 -137.153 1450.1L-47.6012 1784.31C-3.50367 1948.88 165.658 2046.55 330.233 2002.45L837.889 1866.42C900.04 1849.77 955.428 1814.1 996.301 1764.41L1374.23 1304.94C1564.84 1073.2 1345.95 733.315 1056.12 810.975L684.21 910.629Z",
    fill: "#FF6D3F",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1774.06 1067.92C1735.34 923.435 1541.32 897.799 1466.41 1027.27L1138.92 1593.27C1056.33 1736 1187.64 1907.29 1346.93 1864.61L1765.92 1752.34C1864.61 1725.9 1923.18 1624.46 1896.74 1525.77L1774.06 1067.92Z",
    fill: "#FF6D3F",
    fillOpacity: 0.4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4_120",
    x: -1081.74,
    y: -134.323,
    width: 3461.55,
    height: 3081.36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 467,
    result: "effect1_foregroundBlur_4_120"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4_120",
    x: 799.461,
    y: 629.365,
    width: 1417.62,
    height: 1555.9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 157,
    result: "effect1_foregroundBlur_4_120"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1052,
    fill: "white",
    transform: "matrix(-1 0 0 1 1920 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundshade);
export default __webpack_public_path__ + "static/media/backgroundshade.7faa345af071b30eb283f100ebdf6862.svg";
export { ForwardRef as ReactComponent };